import React, { useState, useEffect, useContext } from 'react';
import {
  AppContext,
  SuperTable,
  SkeletonTableLoading,
  getDefaultValue,
  updateConditions,
  getDateOperators,
  getUnifiedConditions,
  ALL_TABLES,
  getTableRowCount,
  saveTableRowCount,
  getAllColumnWidth,
  saveColumnWidth,
  getTranslatedText,
  EventEmitter,
  useIsAuthorisedHook
} from '@nile/components';
import { useKbContext } from '../../contexts/KbContext';
import { useIntl } from 'react-intl';
import {
  KB_ITEM_LIST_VIEW_META,
  GET_KB_ITEMS_LIST
} from '@nile/rmm/src/modules/knowledge-base/graphql';
import { AccountClient, GET_ENTITY_NAMES_META, RMMClient } from '@nile/graphql';
import { useQuery, useLazyQuery } from '@apollo/client';
import { getProcessedConfig } from '@nile/rmm/src/modules/common/services/tableHelper';
import TextCell from '@nile/banyan/src/Components/Tables/TextCell';
import {
  checkDynamicQuery,
  getVariables,
  getWidthPersonalization,
  getColumnCellType,
  getAccessor,
  DEFAULT_FILTER_CONDITION,
  getEntityAttributeName,
  generateOptions,
  getDynamicQuery
} from './table-helper';
import { CollectionCell, DeleteCell } from './cells';
import {
  KB_CONSTANTS,
  KB_ROUTE_ID,
  KB_ROUTE
} from '@nile/rmm/src/modules/knowledge-base';
import envConfig from '@nile/home/src/Config/env';
import DateCell from '@nile/rmm/src/modules/alert-management/components/sub-pages/date-cell';
import AvatarCell from '@nile/reports/src/modules/reports/components/subpages/HistoryTable/Cell/AvatarCell';
import { withRouter } from 'react-router-dom';
import { isEmpty } from 'lodash';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import { KB_ARTICLE_MODULE } from '../../helper/constants';
const KbListView = ({ history }) => {
  const {
    activeViewConfig,
    treeItems,
    bulkRecord,
    setbulkRecord,
    setFilterConditions
  } = useKbContext();
  const appContext = useContext(AppContext);
  const tabContext = useContext(TabContext);
  const { user } = appContext;
  const intl = useIntl();
  const [kbListItems, setKbListItems] = useState([]);
  const [viewLoading, setViewLoading] = useState(true);
  const [listInfo, setListInfo] = useState({});
  const [listInfoTableDetails, setListInfoTableDetails] = useState({});
  const [sort, setSort] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [viewConditions, setViewConditions] = useState(null);
  const tableName = ALL_TABLES.kbListTable;
  const columnWidthObject = getAllColumnWidth(tableName);
  const ROW_COUNT = getTableRowCount(tableName);
  const [rowCount, setRowCount] = useState(ROW_COUNT);

  const getQueryVariables = (type, collectionId = null) => {
    const ARTICLE_DEFAULT_OPERANDS = [
      {
        attribute: 'itemType',
        operator: 'is',
        value: KB_CONSTANTS.KB_ARTICLE
      }
    ];

    const DRAFT_DEFAULT_OPERANDS = [
      {
        attribute: 'itemType',
        operator: 'is',
        value: KB_CONSTANTS.KB_ARTICLE
      },
      {
        attribute: 'status',
        operator: 'is',
        value: 'DRAFT'
      }
    ];

    const COLLECTION_DEFAULT_OPERANDS = [
      {
        attribute: 'parent.itemId',
        operator: 'is',
        value: collectionId
      }
    ];

    const defaultSort = type === KB_CONSTANTS.SOURCE_COLLECTION_TREE ? [
      {
        attribute: 'itemType',
        order: 'ASC'
      },
      {
        attribute: 'lastModifiedOn',
        order: 'DESC'
      }
    ] : [
      {
        attribute: 'lastModifiedOn',
        order: 'DESC'
      }
    ];

    // const collectionSort = [
    //   {
    //     attribute: 'itemType',
    //     order: 'DESC'
    //   },
    //   {
    //     attribute: 'lastModifiedOn',
    //     order: 'DESC'
    //   }
    // ];

    const defaultVariables = {
      listInfo: {
        page: 1,
        pageSize: ROW_COUNT,
        sort: listInfo?.sort || defaultSort
      }
    };

    let operands;
    switch (type) {
      case KB_ROUTE_ID.ALL_ARTICLES:
        operands = ARTICLE_DEFAULT_OPERANDS;
        break;
      case KB_ROUTE_ID.DRAFT:
        operands = DRAFT_DEFAULT_OPERANDS;
        break;
      case KB_CONSTANTS.SOURCE_COLLECTION_TREE:
        operands = COLLECTION_DEFAULT_OPERANDS;
        break;
      default:
        operands = ARTICLE_DEFAULT_OPERANDS;
    }

    return {
      ...defaultVariables,
      operands
    };
  };

  const { loading: kbListViewMetaLoading, data: kbListViewMeta } = useQuery(
    KB_ITEM_LIST_VIEW_META,
    {
      client: AccountClient
    }
  );

  const {
    data: entityMeta = { getEntitiesMeta: [] },
    loading: entityDataLoading
  } = useQuery(GET_ENTITY_NAMES_META, {
    client: RMMClient,
    variables: {
      entitiesName: ['User', 'KbItem']
    }
  });

  const [getKbItemsList, { data, loading }] = useLazyQuery(GET_KB_ITEMS_LIST, {
    client: AccountClient,
    fetchPolicy: 'network-only',
    onCompleted: ({ getKbItems: data }) => {
      setTotalCount(data?.listInfo.totalCount || 0);
      const validSortItems = data?.listInfo?.sort?.filter(
        (listInfoSortItem) => {
          return sort?.some(
            (sortItem) => sortItem.attribute === listInfoSortItem.attribute
          );
        }
      );
      setListInfoTableDetails({
        ...data?.listInfo,
        sort: validSortItems || null
      });
      setListInfo(data?.listInfo);
      setKbListItems(data?.items);
    }
  });

  const fetchItems = (currentView, updatedCondition = null, options = {}) => {
    const type =
      currentView?.source === KB_CONSTANTS.SOURCE_LIST_TABLE
        ? currentView?.data?.selectedViewId
        : currentView?.source;

    const { listInfo: queryListInfo, operands } = getQueryVariables(
      type,
      currentView?.activeItemId
    );

    if (!isEmpty(options)) {
      getKbItemsList({
        variables: {
          listInfo: {
            ...options,
            condition: options?.condition || {
              joinOperator: 'AND',
              operands: [
                {
                  joinOperator: 'AND',
                  operands
                }
              ]
            }
          }
        }
      });
      return;
    }

    if (!updatedCondition) {
      getKbItemsList({
        variables: {
          listInfo: {
            ...(!isEmpty(options) ? options : queryListInfo),
            condition: {
              joinOperator: 'AND',
              operands: [
                {
                  joinOperator: 'AND',
                  operands
                }
              ]
            }
          }
        }
      });
      setViewConditions(null);
      setFilterConditions(null);
      return;
    }

    const params = {
      conditions: viewConditions,
      defaultCondition: [],
      updatedCondition: updatedCondition
    };
    const complexCondition = getUnifiedConditions(params);
    setViewConditions(complexCondition);
    setFilterConditions({
      condition: true,
      resetFilter: () => {
        setViewConditions(null);
        fetchItems(activeViewConfig);
      }
    });

    getKbItemsList({
      variables: {
        listInfo: {
          ...(!isEmpty(options) ? options : queryListInfo),
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                joinOperator: 'AND',
                operands
              },
              complexCondition
            ]
          }
        }
      }
    });
  };

  useEffect(() => {
    if (!isEmpty(activeViewConfig)) {
      setFilterConditions(null);
      setbulkRecord([]);
      fetchItems(activeViewConfig);
      setViewLoading(false);
    }
    return () => {
      setFilterConditions(null);
      setbulkRecord([]);
    };
  }, [activeViewConfig?.activeItemId, activeViewConfig?.data?.selectedViewId]);

  const columnsConfig = {
    TEXT: TextCell,
    AVATAR: AvatarCell,
    COLLECTION: CollectionCell,
    DATE: DateCell,
    DELETE: DeleteCell
  };

  const { configuredCols } = getProcessedConfig({
    entitiesMeta: entityMeta?.getEntitiesMeta || [],
    allColumns:
      kbListViewMeta?.getKbItemListViewMeta?.defaultSelectedAttributes,
    intl,
    module: 'KbItem',
    columnPersonalization: [],
    searchAttributes: kbListViewMeta?.getKbItemListViewMeta?.searchAttributes
  });
  const columnsss = configuredCols || [];

  columnsss.push({
    name: 'delete',
    label: '',
    table: 'KbFeedback',
    dataType: 'delete',
    id: 'delete'
  });

  const handleCollectionActions = (col) => {
    if (col.itemType === KB_CONSTANTS.KB_COLLECTION) {
      history.push(`${KB_ROUTE.COLLECTION_VIEW}/${col.itemId}`);
      return;
    } else {
      tabContext.openTab({
        module: KB_ARTICLE_MODULE,
        url: `/kb/article/${col.itemId}/read`,
        data: { ...col, id: col?.itemId }
      });
    }
  };

  const handleColActions = (col) => {
    switch (col.id) {
      case 'name':
        return {
          onClick: handleCollectionActions
        };
      default:
        return {};
    }
  };

  const constructUnifiedConditions = (updatedCondition) => {
    fetchItems(activeViewConfig, updatedCondition);
  };

  function updateAllConditions(condition, selectedField) {
    updateConditions({
      condition,
      selectedField,
      viewConditions: viewConditions?.operands?.[0] || null,
      setConditions: constructUnifiedConditions
    });
  }
  const allColumns = columnsss?.map((col) => {
    return {
      header: col.label,
      tableName: tableName,
      // accessor: getAccessor(col),
      accessorKey: getAccessor(col),
      // minSize: getColumnWidth(col),
      // maxSize: getMaxWidth(columnWidthObject, col.id),
      size: getWidthPersonalization(columnWidthObject, col.id),
      id: col?.id,
      type: getColumnCellType(col),
      disableSortBy: kbListViewMeta?.getKbItemListViewMeta?.sortAttributes?.includes(
        col.id
      )
        ? false
        : true,
      disableFilters: col?.id === 'delete' ? true : false,
      disableResizing: false,
      field: col,
      actions: handleColActions(col),
      helpers: {
        getDefaultValue,
        checkDynamicQuery,
        getDynamicQuery,
        generateOptions,
        getConditionAttributes: getEntityAttributeName,
        getVariables: getVariables.bind(this, col),
        updateConditions: updateAllConditions,
        getDateOperators,
        entity: 'KbItem'
      }
    };
  });

  const checkBoxDisabledCheck = (row) => {
    return row.itemType === KB_CONSTANTS.KB_COLLECTION;
  };

  function refreshTable(context, data) {
    if (data) {
      setSort(data?.sort || null);
      const options = {
        page: data?.page || 1,
        pageSize: ROW_COUNT,
        sort: data?.sort
          ? [
              {
                attribute: 'itemType',
                order: 'ASC'
              },
              ...data?.sort
            ]
          : listInfo?.sort,
        condition: listInfo?.condition
      };
      fetchItems(activeViewConfig, null, options);
    }
  }

  useEffect(() => {
    EventEmitter.subscribe(KB_CONSTANTS.KB_LIST_TABLE_REFETCH_EVENT, () => {
      fetchItems(activeViewConfig);
    });
    return () => {
      EventEmitter.unsubscribe(KB_CONSTANTS.KB_LIST_TABLE_REFETCH_EVENT);
    };
  }, [activeViewConfig]);

  return (
    <div className="full-height">
      {entityDataLoading || kbListViewMetaLoading || viewLoading ? (
        <SkeletonTableLoading borderTop />
      ) : (
        <SuperTable
          data={kbListItems || []}
          columns={[{ Header: 'Name', header: 'name', columns: allColumns }]}
          listInfo={listInfoTableDetails}
          refreshTable={refreshTable}
          defaultColumnCells={columnsConfig}
          context={{
            records: bulkRecord,
            setRecords: (selected) => {
              const selectFiltered = selected.filter(
                (item) => !checkBoxDisabledCheck(item)
              );
              setbulkRecord(selectFiltered);
            },
            viewConditions: viewConditions?.operands?.[0] ?? null
          }}
          columnWidthPersonalization
          tableName={tableName}
          user={user}
          getEntityAttributeName={getEntityAttributeName}
          getAttributeName={getEntityAttributeName}
          saveColumnWidth={saveColumnWidth}
          saveTableRowCount={saveTableRowCount}
          rowCount={rowCount}
          setRowCount={setRowCount}
          recordCount={totalCount}
          fullHeight
          noBulkSelect={!useIsAuthorisedHook('knowledgeBase.edit')}
          isLoading={loading}
          checkBoxDisabledCheck={checkBoxDisabledCheck}
          emptyState={{
            nodataImage: `${envConfig.imageRoot}svg/kb-not-found.svg`,
            heading: getTranslatedText(intl, 'app.kb.list.noItems.heading')
            // description: getTranslatedText(intl, 'app.kb.noItems.description')
          }}
        />
      )}
    </div>
  );
};

export default withRouter(KbListView);
